import window1 from "../assets/windows/window1.jpg";
import window2 from "../assets/windows/window2.jpg";
import window3 from "../assets/windows/window3.jpg";
import window4 from "../assets/windows/window4.jpg";
import window5 from "../assets/windows/window5.jpg";
import window6 from "../assets/windows/window6.jpg";
import window7 from "../assets/windows/window7.jpg";
import window8 from "../assets/windows/window8.jpg";
import window10 from "../assets/windows/window10.jpg";
import window11 from "../assets/windows/window11.jpg";
import window12 from "../assets/windows/window12.jpg";
import window14 from "../assets/windows/window14.jpg";
import window16 from "../assets/windows/window16.jpg";
import window17 from "../assets/windows/window17.jpg";
import window18 from "../assets/windows/window18.jpg";
import window19 from "../assets/windows/window19.jpg";
import window20 from "../assets/windows/window20.jpg";
import window22 from "../assets/windows/window22.jpg";
import window23 from "../assets/windows/window23.jpg";
import window24 from "../assets/windows/window24.jpg";
import window25 from "../assets/windows/window25.jpg";
import window26 from "../assets/windows/window26.jpg";
import window27 from "../assets/windows/window27.jpg";







export const windows = [
  { id: 1, image: window1 },
  { id: 2, image: window2 },
  { id: 3, image: window3 },
  { id: 4, image: window4 },
  { id: 5, image: window5 },
  { id: 6, image: window6 },
  { id: 7, image: window7 },
  { id: 8, image: window8 },
  { id: 10, image: window10 },
  { id: 11, image: window11 },
  { id: 12, image: window12 },
  { id: 14, image: window14 },
  { id: 16, image: window16 },
  { id: 17, image: window17 },
  { id: 18, image: window18 },
  {id: 19, image: window19 },
  { id: 20, image: window20 },
  { id: 22, image: window22 },
  { id: 23, image: window23 },
  { id: 24, image: window24 },
  { id: 25, image: window25 },
  { id: 26, image: window26 },
  { id: 27, image: window27 },

];